import { useField } from 'formik';
import React from 'react';
import { useIntl } from 'react-intl';
import FormGroup from './FormGroup';
import FormLabel from './FormLabel';

export interface FormInputFieldProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  label?: string;
}

const FormInputField: React.FC<FormInputFieldProps> = ({
  name,
  className,
  label,
  children,
  ...inputProps
}) => {
  const [field, { touched, error }] = useField(name);
  const { formatMessage } = useIntl();

  return (
    <FormGroup
      className={className}
      error={touched && error && formatMessage({ id: error })}
    >
      <FormLabel htmlFor={field.name}>{label}</FormLabel>
      <input className="f-field__control" {...field} {...inputProps} />
      {children}
    </FormGroup>
  );
};

export default FormInputField;
